exports.EventEmitter = require('./event-emitter').EventEmitter;
exports.EventEmitterManager = require('./eventemitter-manager').EventEmitterManager;
exports.PropagatingEventEmitter = require('./propagating-event-emitter').PropagatingEventEmitter;



// Event constants
exports.eventTypes = { };
[
  'stop',
  'nofunds',
  'readyStateChange', // @TODO - change this to be emitted from the scheduler as the scheduler says it reaches specific points in setting up the job.
  'complete', // @TODO - ensure this event works. It might not be needed / might need a name change.
].forEach(eventName => exports.eventTypes[eventName] = { reliable: true });

[
  'console',
  'result',
  'error',
  'status',
  'noprogress',
  'custom',
  'schedmsg::command',
  'schedmsg::broadcast',
].forEach(eventName => exports.eventTypes[eventName] = { reliable: false });

exports.events = {};

Object.keys(exports.eventTypes).forEach(eventName => exports.events[eventName] = eventName);
